import { render, staticRenderFns } from "./AutoCheckVIC.vue?vue&type=template&id=66b5d182&"
import script from "./AutoCheckVIC.vue?vue&type=script&lang=js&"
export * from "./AutoCheckVIC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports